import React from 'react';
import { ButtonWrapper } from './styles';

const FloatingButton = ({ children, wrapperStyles, ...rest }) => (
  <ButtonWrapper {...wrapperStyles} {...rest}>{children}</ButtonWrapper>
);

export default FloatingButton;
